import styled from "styled-components";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import {setBackSchemaStateField} from "../../../features/schemaManageSlice";
import React from "react";
import BackTableView from "./BackTableView";
import {createPortal} from "react-dom";
import AsideHeaderFrontSchemaFunc from "../front/AsideHeaderFrontSchemaFunc";
import AsideHeaderBackSchemaFunc from "./AsideHeaderBackSchemaFunc";
import CreateNewBackTableSchema from "./CreateNewBackTableSchema";

export default function BackSchemaManage({projectName}: { projectName: string }) {

    const tableNames = useAppSelector(state => state.schemaManage.back.proj!.tableNames);
    const mode = useAppSelector(state => state.schemaManage.back.mode);
    const selectedTable = useAppSelector(state => state.schemaManage.back.selectedTable);
    let sideHeaderReady = useAppSelector(state => state.layout.sideHeaderReady);
    const dispatch = useAppDispatch();

    const addMode = mode === "add";

    return <Container>
        {!addMode && <div className={'tables-list'}>
            <UL>
                {tableNames.map((t => <li key={t}>
                    <Btn $active={t === selectedTable}
                         onClick={() => dispatch(setBackSchemaStateField("selectedTable", t))}>
                        {t}
                    </Btn>
                </li>))}
            </UL>
        </div>}
        {selectedTable && !addMode && <div className={'view-back-table'}>
            <BackTableView tableName={selectedTable}/>
        </div>}
        {addMode && <CreateNewBackTableSchema projectName={projectName} />}
        {sideHeaderReady && createPortal(<AsideHeaderBackSchemaFunc />,
            document.getElementById("side-head-content")!)}
    </Container>
}

const Container = styled.section`

    display: flex;
    flex-flow: column;
    gap: .5rem;
    justify-content: center;
    //align-items: center;
    
    .view-back-table {
        //max-width: 1200px;
        display: flex;
        justify-content: center;
    }
    
`

const UL = styled.ul`

    padding: 0;
    display: flex;
    gap: .5rem;
    flex-wrap: wrap;
    justify-content: start;

    //border-bottom: 2px solid var(--table-action-color);

    & .toggle-side-bar {
        margin-right: auto;
    }

    & .fake {
        margin-left: auto;
    }

    & > li {
        white-space: nowrap;
        list-style: none;

        @media (max-width: 500px) {
            flex-basis: 100%;

        }
    }

    & .fake {
        width: 2.4rem;
    }



`

const Btn = styled.button<any>`
    appearance: none;
    background: transparent;
    background: var(--table-row-odd-bg-color);
    padding: .2rem .6rem;
    color: var(--table-row-text-color);
    cursor: pointer;
    width: 100%;
    font-size: 1rem;
    border: none;

    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: .2rem;
    text-align: center;

    ${props => props.$active && `border-bottom: 3px solid var(--table-action-color);`}
    ${props => !props.$active && `border-bottom: 3px solid var(--table-border-color);`}
    &:hover {
        filter: brightness(.85);
    }

    &:disabled {
        filter: grayscale(.6);
    }
`
